module.exports = __webpack_public_path__ + "static/media/sitemap.ee72463a.xml";